import React, {useContext, useState} from 'react'
import cn from 'classnames'
import { Link, useNavigate, useParams } from 'react-router-dom'
import styles from './getProgressionMarker.module.sass'
import Card from '../../../../../components/Card'
import Icon from '../../../../../components/Icon'
import addIcon from '../../../../../media/images/icons/light.png'
import ProgressionMarkerCardLayout from '../../../../../components/BuildComponents/Progression/ProgressionMarkerComponent/ProgressionMarkerCardLayout'
import ProgressionMarkerTableLayout from '../../../../../components/BuildComponents/Progression/ProgressionMarkerComponent/ProgressionMarkerTableLayout'
import Form from '../../../../../components/Form'
import { useDispatch, useSelector } from 'react-redux'
import { filterPMAction, getAllProgressionMarkerAction } from '../../../../../redux/action/builds/progression/progressionMarker/progressionMarkerAction'
import { useEffect } from 'react'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ReactComponent as EmptyCurrencyState } from "../../../../../media/images/icons/Currency_Empty_State.svg";
import Loader from "../../../../../components/Loaders/LoaderProgress";
import EmptyState from '../../../../../components/EmptyStates'
import {ReactComponent as Previous} from '../../../../../media/images/icons/previous.svg'
import {ReactComponent as Next} from '../../../../../media/images/icons/next.svg'
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import Stack from '@mui/material/Stack';
import {ReactComponent as ArchiveSvg} from '../../../../../media/images/icons/archive.svg'
import { Skeleton } from '@mui/material'
import SkeletonTable from '../../../../../components/Skeleton/TableSkeleton'
import SkeletonEmptyState from '../../../../../components/Skeleton/EmptyStateSkeleton'
import GlobalStateContext from '../../../../../components/Context/GlobalStates/GlobalStateContext'
import Control from './Filters/Control'
import Navigation from '../../../../../components/Header/SecondaryNavigation';

const GetProgressionMarker = ({className}) => {

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const {appid} = useParams()

  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)
  // Archive
  const [showArchive, setShowArchive] = useState(false)
  // Sort
  const sortList = [{id: 1, name: 'PM Name', value: 'name'}, {id: 2, name: 'Created At', value: 'created_at'}, {id: 3, name: 'Updated At', value: 'updated_at'}]
  const [sortValue, setSortValue] = useState({name: 'updated_at', value: 0})
  const [selectedSort, setSelectedSort] = useState('updated_at')
  const [sort, setSort] = useState([{id: 1, name: 'Ascending'}, {id : 2, name : 'Descending'}])
  const [sortIndex, setSortIndex] = useState(0)
  // Search
  const [search, setSearch] = useState(null)
  const [userAccess, setUserAccess] = useState(false)
  const globalStates = useContext(GlobalStateContext)
  // Skeleton
  const [showSkeleton, setShowSkeleton] = useState(true)

  const getUserAccess = () => {
    if(globalStates && globalStates.user && globalStates.user.memberAccessConfig?.length > 0){
      let appPermission = globalStates.user.memberAccessConfig.filter((obj) => (obj.projectId === appid))
      if(appPermission?.length > 0){
        setUserAccess(appPermission[0].permissions.id === 1 ? true : false)
      }
    }
  }
  
  useEffect(() => {
    getUserAccess()
  }, [])

  const getAllProgressionMarker = async(search) => {
      let progressionMarkerData = {
        ids : [],
        projectId : appid,
        offset: ((page-1)*limit),
        limit: limit,
        // Search
        ...(search && search !== null && search !== '' && {search : search}),
        // Archive
        showArchived: showArchive,
        // Sort
        sortOrder : (sortIndex == 0 ? 'asc' : 'desc'),
        sortField : selectedSort,
      }
      if(!search){
        await dispatch(getAllProgressionMarkerAction(progressionMarkerData, configureSkeleton))
      }else{
        await dispatch(filterPMAction(progressionMarkerData, configureSkeleton))
      }
  }

  let progressionMarker = useSelector((state)=>{
    return state.progressionMarkers.progressionMarker
  })

  let totalPM = useSelector((state)=>{
    return state.progressionMarkers.totalCount
  })

  let isLoading = useSelector((state)=>{
    return state.progressionMarkers.isLoading
  })

  let isFiltered = useSelector((state) => {
    return state.progressionMarkers.isFiltered
  })

  const handlePageChange = (event, value)  => {
    setPage(value)
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  const configureSkeleton = () => {
    setShowSkeleton(true)
    setTimeout(() => {
      setShowSkeleton(false)
    }, 1000)
  }

  useEffect(()=>{
    if(selectedSort !== null){
      getAllProgressionMarker(search)
    }
  }, [page, selectedSort, showArchive])

  const onSearch = (search) => {
    if(search == ''){
      setSearch(null)
      getAllProgressionMarker(null)
    }else{
      setSearch(search)
      getAllProgressionMarker(search)
    }
  }

  // Loader
  if(isLoading){
    return(
      <>
        <div className={styles.loader}>
          <Loader />
        </div>
      </>
    )
  }

  return(
    <>
      <ToastContainer />
      <Navigation type='PM' filterAction={getAllProgressionMarker} search={search} setSearch={onSearch} archive={showArchive} setArchive={setShowArchive} data={sortList} setPage={setPage} sortIndex={sortIndex} setSortIndex={setSortIndex} selected={selectedSort} setSelected={setSelectedSort} sort={sort} setSort={setSort} value={sortValue} setValue={setSortValue} />
      <Card layOut={`Get`} className={styles.card} classCardHead={styles.head}>

        <div className={styles.wrapper}>
          {/* Currency Table View */}
          {showSkeleton && progressionMarker?.length === 0 && 
            <SkeletonEmptyState />
          }
          {showSkeleton && progressionMarker?.length > 0 && 
            <SkeletonTable rows={progressionMarker.length} column={4} controls={2} type={['recatangle', 'recatangle', 'reactangle', 'circular']} colWidth={[36, 100, 100, 36]} colHeight={[36, 15, 25, 36]} />
          }
          {!showSkeleton && !isFiltered && progressionMarker?.length === 0 &&
            <EmptyState access={userAccess} route={`/create-progression-marker/${appid}`} type="PM" />
          }
          {!showSkeleton && !isFiltered && progressionMarker?.length > 0 &&
            <ProgressionMarkerTableLayout access={userAccess} items={progressionMarker} title="Last edited" />
          }
          {!showSkeleton && isFiltered &&
            (progressionMarker?.length > 0 ?
              <ProgressionMarkerTableLayout access={userAccess} items={progressionMarker} title="Last edited" />
            :
              <div className={styles.message}>No Result Found</div>
            )
          }

          {!isLoading && progressionMarker.length > 0 &&
            <div className={styles.pagination}>
              <Stack spacing={2}>
                <Pagination page={page} renderItem={(item) => (
                  <PaginationItem
                    {...item}
                    sx={{
                      '&.MuiPaginationItem-root': {
                        minWidth: '28px',
                        height: '28px',
                        fontSize: '12px'
                      },
                      '&.Mui-selected': {
                        color: 'rgb(255, 255, 255)',
                        fontWeight : 'bold',
                        border : '1px solid rgb(42, 133, 255)',
                        background : 'rgba(42, 133, 255)'
                      },
                      '&.MuiPaginationItem-page.Mui-selected:hover' : {
                        color: 'rgb(255, 255, 255)',
                        fontWeight : 'bold',
                        border : '1px solid rgb(42, 133, 255)',
                        background : 'rgba(42, 133, 255)'
                      }
                    }}
                  />
                )} siblingCount={1} count={Math.ceil(totalPM/limit)} color="primary" onChange={handlePageChange} />
              </Stack>
            </div>
          }
        </div>
      </Card>
      <div className="divider"></div>
      <div className={styles.msg}>
        <p className={styles.alert}>Learn more about progression marker <a className={styles.infoLink} href="https://manual.specterapp.xyz/specter-user-manual/build/progression/progression-markers" target="_blank">Click Here</a></p>
      </div>
    </>
  )

  // return(
  //   <>
  //     <ToastContainer />
  //     <Card layOut={`Get`} className={styles.card} classCardHead={styles.head} title={showSkeleton ? <Skeleton sx={{ bgcolor: 'grey.200', borderRadius : '4px'}} animation="wave" variant="recatangle" width={180} height={32}/> : "Progression Marker"} classTitle={cn("title-purple", styles.title)}
  //       head={
  //         (
  //           <>
  //             <div className={styles.add}>
  //               {showSkeleton && progressionMarker.length > 0 ?
  //                 <Skeleton sx={{ bgcolor: 'grey.200', borderRadius : '8px'}} animation="wave" variant="recatangle" width={98} height={40}/>
  //               : !showSkeleton && progressionMarker.length > 0 ?
  //               <>
  //               {!userAccess &&
  //                 <div className={styles.createButton}>
  //                   <Link to={`/create-progression-marker/${appid}`} className={cn("button-small", styles.button)}><img className={styles.addIcon} src={addIcon} alt='gamehub_add_icon'width={20} height={20}/>Create</Link>
  //                 </div>
  //               }
  //               </>
  //               : ''}
  //             </div>
  //           </>
  //       )
  //       }
  //     >
  //       <div className={styles.wrapper}>
  //           {progressionMarker.length > 0 && <div className={styles.seprator}></div>}
  //             <div className={styles.options}>
  //               <div className={styles.filters}>
  //                 {(showSkeleton && progressionMarker.length > 0) ?
  //                   <>
  //                     <Skeleton Skeleton sx={{ bgcolor: 'grey.200', borderRadius : '8px'}} animation="wave" variant="recatangle" width={74} height={34}/>
  //                     <Skeleton Skeleton sx={{ bgcolor: 'grey.200', borderRadius : '8px'}} animation="wave" variant="recatangle" width={130} height={34}/>
  //                   </>
  //                 : !showSkeleton && progressionMarker.length > 0 ?
  //                   <>
  //                     <div className={cn(styles.buttons, {[styles.active] : showArchive})} onClick={() => setShowArchive(!showArchive)}>
  //                       <ArchiveSvg className={styles.icon} />
  //                       <span className={styles.buttonText}>Show Archived</span>
  //                     </div>
  //                     <Control filters={null} action={getAllProgressionMarker} data={sortList} sortIndex={sortIndex} setSortIndex={setSortIndex} selected={selectedSort} setSelected={setSelectedSort} sort={sort} setSort={setSort} value={sortValue} setValue={setSortValue}/>
  //                   </>
  //                 : ''}
                  
  //               </div>
  //               <div className={styles.searchForm}>
  //               {showSkeleton && progressionMarker.length > 0 ?
  //                 <Skeleton Skeleton sx={{ bgcolor: 'grey.200', borderRadius : '12px'}} animation="wave" variant="recatangle" width={220} height={40}/>
  //               : !showSkeleton && progressionMarker.length > 0 ?
  //                 <Form className={styles.form} placeholder="Search Progression Marker" type="text" name="search" icon="search" onChange={(e) => {onSearch(e.target.value)}}/>
  //               : ''}
  //               </div>
  //           </div>
  //           {showSkeleton && 
  //             (progressionMarker.length == 0 ?
  //               <SkeletonEmptyState />
  //             : 
  //               <SkeletonTable rows={progressionMarker.length} column={5} controls={3} type={['recatangle', 'recatangle', 'recatangle', 'reactangle', 'circular']} colWidth={[36, 100, 100, 100, 40]} colHeight={[36, 25, 25, 25, 40]} />
  //             )
  //           }

  //           {!showSkeleton && 
  //             (progressionMarker.length == 0 ?
  //               <EmptyState access={userAccess} route={`/create-progression-marker/${appid}`} type="PM" />
  //             : searchFlag ?
  //               <>
  //                 {isSearched && <div className={styles.textCenter}><Loader /></div>}
  //                 {!isSearched && filteredPM.length == 0 && <p className={styles.textCenter}>No Result Found</p>}
  //                 {!isSearched && filteredPM.length > 0 && <ProgressionMarkerTableLayout access={userAccess} items={filteredPM} title="Last edited" /> }
  //               </>
  //             : <ProgressionMarkerTableLayout access={userAccess} items={progressionMarker} title="Last edited" /> 
  //             )
  //           }
            
  //           {!isLoading && progressionMarker.length > 0 &&
  //             <div className={styles.pagination}>
  //               <Stack spacing={2}>
  //                 <Pagination renderItem={(item) => (
  //                   <PaginationItem
  //                     {...item}
  //                     sx={{
  //                       '&.Mui-selected': {
  //                         color: 'rgb(255, 255, 255)',
  //                         fontWeight : 'bold',
  //                         border : '1px solid rgb(42, 133, 255)',
  //                         background : 'rgba(42, 133, 255)'
  //                       },
  //                       '&.MuiPaginationItem-page.Mui-selected:hover' : {
  //                         color: 'rgb(255, 255, 255)',
  //                         fontWeight : 'bold',
  //                         border : '1px solid rgb(42, 133, 255)',
  //                         background : 'rgba(42, 133, 255)'
  //                       }
  //                     }}
  //                   />
  //                 )} siblingCount={1} count={Math.ceil(totalPM/limit)} color="primary" onChange={handlePageChange} />
  //               </Stack>
  //             </div>
  //           }
  //       </div>
  //     </Card>
  //     <div className="divider"></div>
  //     <div className={styles.msg}>
  //       <p className={styles.alert}>Learn more about progression marker <a className={styles.infoLink} href="https://manual.specterapp.xyz/specter-user-manual/build/progression/progression-markers" target="_blank">Click Here</a></p>
  //     </div>
  //   </>
  // )
}

export default GetProgressionMarker